import { InjectionToken } from "@angular/core";
export const USER_DATA = new InjectionToken<object>('User data');